var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { QuestionRatingAdornerViewModel } from "survey-creator-core";
import { attachKey2click, ReactElementFactory, SvgIcon } from "survey-react-ui";
import { CreatorModelElement } from "../ModelElement";
var QuestionRatingAdornerComponent = /** @class */ (function (_super) {
    __extends(QuestionRatingAdornerComponent, _super);
    function QuestionRatingAdornerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuestionRatingAdornerComponent.prototype.createModel = function (props) {
        this.modelValue = this.createQuestionViewModel(props);
    };
    QuestionRatingAdornerComponent.prototype.createQuestionViewModel = function (props) {
        return new QuestionRatingAdornerViewModel(props.componentData, props.question, null);
    };
    QuestionRatingAdornerComponent.prototype.getUpdatedModelProps = function () {
        return ["question", "componentData"];
    };
    Object.defineProperty(QuestionRatingAdornerComponent.prototype, "ratingModel", {
        get: function () {
            return this.model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionRatingAdornerComponent.prototype, "model", {
        get: function () {
            return this.modelValue;
        },
        enumerable: false,
        configurable: true
    });
    QuestionRatingAdornerComponent.prototype.getStateElement = function () {
        return this.model;
    };
    QuestionRatingAdornerComponent.prototype.renderElement = function () {
        var model = this.ratingModel;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "svc-rating-question-content" },
                React.createElement("div", { className: model.controlsClassNames },
                    model.allowRemove ? attachKey2click(React.createElement("span", { role: "button", className: model.removeClassNames, "aria-label": model.removeTooltip, onClick: function () { return model.removeItem(model); } },
                        React.createElement(SvgIcon, { size: "auto", iconName: "icon-remove_16x16", title: model.removeTooltip }))) : null,
                    model.allowAdd ? attachKey2click(React.createElement("span", { role: "button", className: model.addClassNames, "aria-label": model.addTooltip, onClick: function () { return model.addItem(model); } },
                        React.createElement(SvgIcon, { size: "auto", iconName: "icon-add_16x16", title: model.addTooltip }))) : null),
                this.props.element)));
    };
    return QuestionRatingAdornerComponent;
}(CreatorModelElement));
export { QuestionRatingAdornerComponent };
ReactElementFactory.Instance.registerElement("svc-rating-question", function (props) {
    return React.createElement(QuestionRatingAdornerComponent, props);
});
ReactElementFactory.Instance.registerElement("svc-rating-question-content", function (props) {
    return React.createElement(QuestionRatingAdornerComponent, props);
});
